import {ClientOfferAtRiskFilterValue, ClientOfferAtRiskPageAction} from "./ClientOfferAtRiskPage";
import React, {useEffect, useState} from "react";
import {AutoCompleteMultiInput, MultiFilterButton} from "common";
import DatePicker from "react-datepicker";
import {DatePickerInput} from "common/component/DatePickerInput";
import {subYears} from "date-fns";

type ClientOfferAtRiskFilterProps = {
    initFilterValue: ClientOfferAtRiskFilterValue,
    dispatch: React.Dispatch<ClientOfferAtRiskPageAction>
}

const ClientOfferAtRiskFilter = ({initFilterValue, dispatch}: ClientOfferAtRiskFilterProps) => {
    const [filterValue, setFilterValue] = useState({...initFilterValue});
    useEffect(() => {
        setFilterValue(initFilterValue);
    }, [initFilterValue])
    const onFilterUpdate = (fieldName: string, fieldValue: any) => {
        setFilterValue({...filterValue, [fieldName]: fieldValue})
    }
    const threeYearsAgo = subYears(new Date(), 3);

    return <MultiFilterButton<ClientOfferAtRiskFilterValue>
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        emptyFilterValue={{
            fromDate: null,
            toDate: null,
            cities: "",
        }}
        dispatchSetFilterValue={(val) => dispatch({type: "SET_FILTER", filter: val})}
        filterOptions={[
            {
                label: "City",
                component: <AutoCompleteMultiInput field={'cities'}
                                                   fieldValue={filterValue.cities}
                                                   queryType='city'
                                                   inputType='char-only'
                                                   setFieldValue={(val) => onFilterUpdate("cities", val)}/>
            },
            {
                label: "Response Due Date From",
                component: <DatePicker
                    wrapperClassName="w-full"
                    minDate={threeYearsAgo}
                    selected={filterValue.fromDate || null}
                    onSelect={(newValue: Date | null) => onFilterUpdate("fromDate", newValue)}
                    onChange={() => {}}
                    customInput={<DatePickerInput
                        fieldName="fromDate"
                        value={undefined}
                        onFinish={(newValue: Date | null) => {
                            if (!newValue || newValue >= threeYearsAgo) {
                                onFilterUpdate("fromDate", newValue);
                            }
                        }}
                    />}
                />
            },
            {
                label: "Response Due Date To",
                component: <DatePicker
                    wrapperClassName="w-full"
                    minDate={threeYearsAgo}
                    selected={filterValue.toDate || null}
                    onSelect={(newValue: Date | null) => onFilterUpdate("toDate", newValue)}
                    onChange={() => {}}
                    customInput={<DatePickerInput
                        fieldName="toDate"
                        value={undefined}
                        onFinish={(newValue: Date | null) => {
                            if (!newValue || newValue >= threeYearsAgo) {
                                onFilterUpdate("toDate", newValue);
                            }
                        }}
                    />}
                />
            },
        ]}
    />
}

export default ClientOfferAtRiskFilter;